import { FlowUnitsAPIType, PressureUnitsAPIType } from '@shared/models';
import { t } from '@lingui/macro';
import { TimePeriodType } from './Range';
import { SiteType } from './Site';

export interface SiteSummaryModel {
  siteId: number;
  siteType: SiteType;
  primaryAddress: string;
}

export interface ChannelSummaryModel {
  channelNo: number;
  channelType: string;
  channelName: string;
  isAnalogue: boolean;
}

export interface DeviceDataModel {
  date: string; // as date
  value: number;
}

export interface ChannelDataModel {
  channelSummary: ChannelSummaryModel;
  deviceData: DeviceDataModel[];
}

export interface MainGraphDataModel {
  siteSummary: SiteSummaryModel;
  channelData: ChannelDataModel[];
}

// bands
export interface GraphBoundariesModel<T> extends Record<GraphBoundariesType, T> {}

export enum GraphBoundariesType {
  Actuator = 'Actuator',
  Target = 'Target',
  CP = 'CP',
}

export const GraphBoundariesOptionsFn = (): GraphBoundariesModel<BoundaryAndActuationsBaseModel> => ({
  [GraphBoundariesType.Actuator]: {
    label: t`Actuator Limits`,
    scale: 'Pressure',
    state: false,
  },
  [GraphBoundariesType.Target]: {
    label: t`Target Pressure`,
    scale: 'Pressure',
    state: false,
  },
  [GraphBoundariesType.CP]: {
    label: t`CP Alarm Pressure`,
    scale: 'Pressure',
    state: false,
  },
});

export interface BoundaryAndActuationsBaseModel {
  label: string;
  scale: string;
  state: boolean;
}

// additional
export interface GraphDataGetModel {
  timePeriod?: TimePeriodType | 'Custom';
  interval: GraphIntervalType;
  customFrom: string;
  customTo: string;
  flowUnit?: FlowUnitsAPIType;
  pressureUnit?: PressureUnitsAPIType;
}

export enum GraphIntervalType {
  Auto = 'Auto',
  Device = 'Device',
  Min1 = 'Min1',
  Min5 = 'Min5',
  Min10 = 'Min10',
  Min15 = 'Min15',
  Min30 = 'Min30',
  Hour1 = 'Hour1',
  Hour6 = 'Hour6',
  Hour12 = 'Hour12',
  Day1 = 'Day1',
}

export const GraphIntervalOptionsFn = (): Record<GraphIntervalType, string> => ({
  [GraphIntervalType.Auto]: t`Auto`,
  [GraphIntervalType.Device]: t`Device`,
  [GraphIntervalType.Min1]: '1 ' + t`Minute`,
  [GraphIntervalType.Min5]: '5 ' + t`Minutes`,
  [GraphIntervalType.Min10]: '10 ' + t`Minutes`,
  [GraphIntervalType.Min15]: '15 ' + t`Minutes`,
  [GraphIntervalType.Min30]: '30 ' + t`Minutes`,
  [GraphIntervalType.Hour1]: '1 ' + t`Hour`,
  [GraphIntervalType.Hour6]: '6 ' + t`Hours`,
  [GraphIntervalType.Hour12]: '12 ' + t`Hours`,
  [GraphIntervalType.Day1]: '1 ' + t`Day`,
});
